import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class CourseAPI extends BaseAPI {}

export default new CourseAPI('v1/courses', 'Course')
